import * as authLogin from 'store/actions/auth/authLogin';
import * as authLogout from 'store/actions/auth/authLogout';
import * as requests from 'http/requests/authRequests';
import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import { clearToken, refreshToken } from 'http/clientToken';

function* authLoginAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    refreshToken();

    try {
        const response = yield requests.loginRequest(values);

        yield put(authLogin.authLoginSuccess(response));

        onSuccess && onSuccess(response);

    } catch (error) {
        yield put(authLogin.authLoginFailure(error));

        onError && onError(error);
    }
}

function* authLoginFailureAsync() {
    yield put(showNotification('auth.login.notifications.failure', 'warning'));
}

function* authLogoutAsync({ payload }) {
    const {
        onError,
        onSuccess,
    } = payload;

    try {
        yield requests.logoutRequest();

        clearToken();

        yield put(authLogout.authLogoutSuccess());

        onSuccess && onSuccess();
    } catch (error) {
        yield put(authLogout.authLogoutFailure());

        onError && onError(error);
    }
}

function* authLogoutFailureAsync() {
    yield put(showNotification('auth.logout.notifications.failure', 'warning'));
}

function* authLogoutSuccessAsync() {
    yield put(showNotification('auth.logout.notifications.success', 'warning'));
}

export default function* () {
    yield [
        takeEvery(types.AUTH_LOGIN, authLoginAsync),
        takeEvery(types.AUTH_LOGIN_FAILURE, authLoginFailureAsync),

        takeEvery(types.AUTH_LOGOUT, authLogoutAsync),
        takeEvery(types.AUTH_LOGOUT_FAILURE, authLogoutFailureAsync),
        takeEvery(types.AUTH_LOGOUT_SUCCESS, authLogoutSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/authSagas.js